import { computed, inject, Injectable } from '@angular/core';
import { OrderApiResponseStateService } from './order-api-response-state.service';
import { OrderFlowType } from '../../../../../models/order/order.model';

@Injectable({ providedIn: 'root' })
export class CreditCheckResponseService {
    private orderApiResponseStateService = inject(OrderApiResponseStateService);

    CCResponse = this.orderApiResponseStateService.creditCheckData;

    internetAttCreditDecision = computed(() => {
        const ccResponse = this.CCResponse();
        return ccResponse?.ATTCreditDecision ?? null;
    });
    
    internetRc1CreditDecision = computed(() => {
        const ccResponse = this.CCResponse();
        return ccResponse?.RC1CreditDecision ?? null;
    })

    internetCreditDecision = computed(() => {
        const ccResponse = this.CCResponse();
        return ccResponse?.ATTCreditDecision ?? ccResponse?.RC1CreditDecision ?? null;
    });
    videoCreditDecision = computed(() => {
        const ccResponse = this.CCResponse();
        return ccResponse?.DTVCreditDecision ?? null;
    });
    wirelessCreditDecision = computed(() => {
        const ccResponse = this.CCResponse();
        return ccResponse?.WirelessCreditDecision ?? null;
    });

    hasVideoCreditDecision = computed(() => !!this.videoCreditDecision());
    hasWirelessCreditDecision = computed(() => !!this.wirelessCreditDecision());
    hasInternetCreditDecision = computed(() => !!this.internetCreditDecision());
    hasVoiceCreditDecision = computed(() => !!this.voiceCreditDecision());

    voiceCreditDecision = this.internetCreditDecision;

    getCreditDecisionOnType(type: OrderFlowType) {
        switch (type) {
            case OrderFlowType.Internet:
                return this.internetCreditDecision();
            case OrderFlowType.Video:
                return this.videoCreditDecision();
            case OrderFlowType.Wireless:
                return this.wirelessCreditDecision();
            case OrderFlowType.Voice:
                return this.voiceCreditDecision();
            default:
                return null;
        }
    }

    getErrorResponse(flowType: string) {
        const response = this.CCResponse();
        if (response) {
            const errorResponse = response.ResponseHeader?.ProductResponse?.find(x => x.Type?.toLocaleLowerCase() === flowType.toLocaleLowerCase() && String(x?.Code ?? '').trim() !== '0000');
            if (errorResponse) {
                return { code: errorResponse.Code, message: errorResponse.Message ?? 'Unable to fetch credit check results, please try later.' };
            }
        }
        return null;
    }
}
